import React, { useState } from 'react';

const Input = ({
  id,
  type,
  placeholder,
  hasError,
  errorMessage,
  isDisabled,
  leadingIcon,
  trailingIcon,
  label,
  supportingText,
  maxLength,
  name,
  onBlur,
  onChange,
  onKeyUp,
  value,
  forgotPasswordLink,
  forgotPasswordText,
  additionalClasses,
  clearInput,
  autocomplete,
  defaultValue,
  onKeyDown,
  tabIndex,
  inputClassName,
  showLabelTooltip,
  max,
  min,
  required,
  onClickTrailingIcon,
  ref,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const showClearButton = clearInput && !hasError && value;
  return (
    <div
      className={`thule-input ${isDisabled ? 'disabled' : ''} ${hasError ? 'error' : ''} ${additionalClasses || ''}`}
    >
      {label && (
        <label title={showLabelTooltip ? label : ''} htmlFor={id}>
          {label}
        </label>
      )}
      <div className="position-relative">
        {leadingIcon && <i className={`leading-icon le-icon-${leadingIcon}`}></i>}
        <input
          tabIndex={tabIndex}
          type={type === 'password' && showPassword ? 'text' : type}
          placeholder={`${type === 'password' ? '********' : placeholder ? placeholder : ''}`}
          className={`input ${leadingIcon ? 'ps-9' : ''} ${trailingIcon ? 'pe-9' : ''} ${inputClassName || ''}`}
          id={id}
          disabled={isDisabled}
          max={max}
          min={min}
          maxLength={maxLength}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          onKeyUp={onKeyUp}
          value={value}
          autoComplete={autocomplete}
          defaultValue={defaultValue}
          onKeyDown={onKeyDown}
          ref={ref}
          required={required ? true : null}
          aria-describedby={errorMessage ? 'input-error-message-' + id : null}
        />
        {trailingIcon && !hasError && !showClearButton && (
          <i className={`trailing-icon le-icon-${trailingIcon}`} onClick={onClickTrailingIcon}></i>
        )}

        {showClearButton && (
          <button className="clear-button trailing-icon btn p-0" onClick={clearInput}>
            <span className="sr-only">Clear input</span>
            <i className=" le-icon-x"></i>
          </button>
        )}

        {type === 'password' && (
          <i
            className={`trailing-icon ${showPassword ? 'le-icon-eye-off' : 'le-icon-eye'}`}
            onClick={() => setShowPassword(!showPassword)}
          ></i>
        )}
        {hasError && type !== 'password' && <i className={`trailing-icon le-icon-warning error`}></i>}
      </div>
      {supportingText && !hasError && (
        <div className="supporting-text paragraph--xs" dangerouslySetInnerHTML={{ __html: supportingText }}></div>
      )}
      {hasError && (
        <div
          role="alert"
          className={`supporting-text paragraph--xs error-message ${hasError ? '' : 'd-none'}`}
          dangerouslySetInnerHTML={{ __html: errorMessage }}
          id={'input-error-message-' + id}
          aria-invalid={hasError ? true : null}
        ></div>
      )}
      {type === 'password' && forgotPasswordText && (
        <span className="d-flex justify-content-end mt-3">
          <a href={forgotPasswordLink} className="forgot-password-link paragraph--xs">
            {forgotPasswordText}
          </a>
        </span>
      )}
    </div>
  );
};

Input.displayName = 'Input';
export default Input;
